import { useState } from 'react';
import { History } from 'lucide-react';
import EmptyState from '@/components/patterns/EmptyState.jsx';
import AutomationRunItem from './AutomationRunItem.jsx';

/** Every run of an automation, newest first. The run a link names (`linkedRunId`) starts open, else the newest one, so its outcome is the first thing seen. */
const AutomationRunHistory = ({ runs, workflowId, linkedRunId = null }) => {
  const [openRunId, setOpenRunId] = useState(undefined);
  const linkedRun = linkedRunId ? runs.find((run) => run.id === linkedRunId || run.workflowRunId === linkedRunId) : null;
  const currentOpenId = openRunId === undefined ? (linkedRun || runs[0])?.id : openRunId;

  if (runs.length === 0) {
    return <EmptyState icon={History} title="No runs yet" description="Runs show up here as soon as the automation starts one, on its own or with Run now." />;
  }

  return (
    <ul className="automations-runs" aria-label="Runs">
      {runs.map((run) => (
        <AutomationRunItem key={run.id} run={run} workflowId={workflowId} open={currentOpenId === run.id} linked={linkedRun?.id === run.id} onToggle={() => setOpenRunId(currentOpenId === run.id ? null : run.id)} />
      ))}
    </ul>
  );
};

export default AutomationRunHistory;
